import React, { useContext, useState, useEffect, useRef } from 'react';
import { Container, Typography } from '@mui/material';
import Layout from '../../component/Layout';
import { useLocation, useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import { UserProfile } from '../../contexts/UserContext';
import { SystemProfile } from '../../contexts/SystemContext';
import pdfMake from "pdfmake/build/pdfmake.min";
import pdfFonts from "pdfmake/build/vfs_fonts";
import moment from 'moment-timezone';
import api from '../../connection/Axios';
import orangeArrowRight from '../../assets/orangeArrowRight.png'
import icoArrowRight from '../../assets/icoArrowRight.png'
import icoNewWindow from '../../assets/icoNewWindow.png'
import icoAtencao from '../../assets/icoAtencao.png'
import icoResolvido from '../../assets/icoResolvido.png'
import icoPendente from '../../assets/icoPendente.png'
import { gerarPDF } from './GerarPDF';

pdfMake.vfs = pdfFonts.vfs;

const VistoriaDetalhe = () => {
    const divRef = useRef();
    const location = useLocation()
    const navigation = useNavigate()
    const [userData, setUserData] = useContext(UserProfile)
    const [systemData, setSystemData] = useContext(SystemProfile)
    const [vistoria, setVistoria] = useState([])
    const [startVistoria, setStartVistoria] = useState([])
    const [finalVistoria, setFinalVistoria] = useState([])
    const [getAll, setGetAll] = useState(false)
    const [company, setCompany] = useState([])
    const [vistData, setVistData] = useState([])
    const [pdf, setPdf] = useState(false)
    const [priority, setPriority] = useState(true)
    const [keepPriority, setKeepPriority] = useState(false)
    const [team, setTeam] = useState([])

    const [titBoxPrincipal, setTitBoxPrincipal] = useState('')
    const [openNr, setOpenNr] = useState()
    const [nrContent, setNrContent] = useState([])
    const [openOcorrencia, setOpenOcorrencia] = useState(0)


    const [openReads, setOpenReads] = useState(0)
    const [reads, setReads] = useState([])
    const [openUsers, setOpenUsers] = useState(false)
    const [update, setUpdate] = useState(0)


    useEffect(() => {
        if (location.state && location.state.data) {
            setVistoria(location.state.data);
            setStartVistoria(location.state.data.startVistoria || []);
            setFinalVistoria(location.state.data.finalVistoria || []);
            setGetAll(true);
        }
    }, []);


    useEffect(()=>{
        setTitBoxPrincipal('Ocorrências')
    }, [])
  
  const headers = {
    headers: {
    "Content-Type": "application/json", "Access-Control-Allow-Origin": "*",
    "Authorization": `Bearer ${userData.token}`
}};


  const data = {
    cmpanyId: vistoria.company
  }

  useEffect(()=>{
    if(getAll){
        api.post('company/getCompany', data, headers).then(response =>  {
            setCompany(response.data)
        })
    }
    setVistData(vistoria.data)
  }, [getAll])

  function OpenAddUsers(){
    setOpenUsers(!openUsers)
    if(team.length === 0){
        GetAllUsers()
    }
  }

  async function GetAllUsers(){
    if(vistoria.equipe !== undefined){
        await api.post('auth/getTeam', {companyId: vistoria.company}, headers).then(response => {
            setTeam(response.data)
        }).catch(error => {
            console.log(error.message)
        })
    }
  }


  const dataServiceRevisar = {
    id: vistoria.id,
    status: 'atencao'
  }

  const dataServiceFinalizado = {
    id: vistoria.id,
    status: 'resolvido'
  }

  async function SaveServiceRevisar(){
    if (vistoria.status === 'resolvido') {
        setPdf(true)
    } else {
        await api.post('/vistoria/updateService', dataServiceRevisar, headers
        ).then(response => {
            setVistoria(response.data)
            setPriority(false)
            setSystemData({...systemData, error: 'Inspeção atualizada com sucesso.', typeError: 'success'})
            navigation('/vistorias-em-aberto')
        }).catch(error => {
            setSystemData({...systemData, error: 'Ocorreu um erro.', typeError: 'error'})
            console.log(error.message)
        })
    }
  }

  async function SaveServiceFinalizado(){
    if (vistoria.status === 'resolvido') {
        setPdf(true)
    } else {
        await api.post('/vistoria/updateService', dataServiceFinalizado, headers
        ).then(response => {
            setVistoria(response.data)
            setPriority(false)
            setSystemData({...systemData, error: 'Inspeção atualizada com sucesso.', typeError: 'success'})
            navigation('/vistorias-em-aberto')
        }).catch(error => {
            setSystemData({...systemData, error: 'Ocorreu um erro.', typeError: 'error'})
            console.log(error.message)
        })
    }
  }


function ShowNr(nr, index, value) {
    setTitBoxPrincipal(value)
    setOpenNr(index + 1)
    setNrContent(nr)
}

function ShowOcorrencia(ocorrencia, index) {
    setOpenOcorrencia(index + 1)
    setReads([])
}

  const StatusColor = () => {
    switch (vistoria.status) {
        case 'naoiniciada' : return <div style={{borderColor: '#f1f1f1', backgroundColor: '#f1f1f1', color: 'grey', marginBottom: 15}} className='vistoriaStatus'><b>Status:&nbsp;&nbsp;Não Iniciada</b></div>
        case 'pendente' : return <div style={{borderColor: '#ff8536', backgroundColor: '#ff8536', color: '#ffffff', marginBottom: 15}} className='vistoriaStatus'><b>Status:&nbsp;&nbsp;Pendente</b></div>
        case 'atencao' : return <div style={{borderColor: '#aa0000', ackgroundColor: '#aa0000', color: 'red', marginBottom: 15}} className='vistoriaStatus'><b>Status:&nbsp;&nbsp;Atenção</b></div>
        case 'resolvido' : return <div style={{borderColor: '#494949', backgroundColor: '#494949', color: '#ffffff', marginBottom: 15}} className='vistoriaStatus'><b>Status:&nbsp;&nbsp;Resolvido</b></div>
        default : return '#000000' 
    }
}

const vistoriaArray = Array.isArray(vistoria) ? vistoria : [vistoria];


async function GetReads(value) {
    await api.post('getMessages/message', {id: value}, headers ).then(response => {
        setReads(response.data)
    })
}

function removeTeamMember(index) {
  const updated = {
    ...vistoria,
    equipe: vistoria.equipe.filter((_, i) => i !== index)
  };
  setVistoria(updated)
  UpdateEquipe();
}



async function UpdateEquipe(vistoriaData = vistoria) {
  try {
    const response = await api.post('/vistoria/updateEquipe', {id: vistoria.id, equipe: vistoria.equipe}, headers);
    setSystemData({
      ...systemData,
      error: 'Inspeção atualizada com sucesso.',
      typeError: 'success'
    });
  } catch (error) {
    setSystemData({
      ...systemData,
      error: 'Ocorreu um erro.',
      typeError: 'error'
    });
    console.log(error.message);
  }
}

useEffect(() => {
  if (vistoria && Object.keys(vistoria).length > 0) {
    UpdateEquipe()
    console.log('vai uai')
  }
}, [vistoria])

useEffect(()=>{
    if(openUsers) {
        GetAllUsers()
    }
}, [openUsers])


  return (
    <>
        <Layout breadcrumb='Dashboard / Inspeções / Detalhe da Inspeção' title='Detalhe da Inspeção'>
<div ref={divRef} style={{backgroundColor: '#ffffff'}}>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between',backgroundColor: '#ffffff', borderRadius: 10, padding: 20}}>
            <div>
                <div style={{color: '#ed6e2d', fontSize: 19, fontWeight: 600, marginBottom: 5}}>{vistoria.empreend}</div>
                <div style={{color: '#262525', fontSize: 15, fontWeight: 600, marginBottom: 5}}>Cod.: {vistoria.id}</div>
                <div style={{color: '#787878', fontSize: 13, }}>{company?.nomeFantasia}</div>
            </div>
            <div style={{display: 'flex', alignItems: 'flex-end', flexDirection: 'column'}}>
                <StatusColor />
                {vistoria?.status === 'naoiniciada' ?
                    <div style={{color: '#787878', fontSize: 12, textAlign: 'right', alignItems: 'end'}}>
                        <span style={{color: '#000000'}}>Iniciada em:</span> {vistoria?.startVistoria ? moment(vistoria.startVistoria).format('DD/MM/YYYY - HH:mm') : 'Inspeção aguardando início'}<br />
                    </div>
                :   <div style={{color: '#787878'}}><span style={{color: '#000000'}}>Iniciada em:</span> Inspeção ainda não iniciada</div>  }
                {vistoria.finalVistoria !== undefined ?
                    <div style={{color: '#000000', fontSize: 13, marginBottom: 15, textAlign: 'right', alignItems: 'end'}}>
                        <div style={{color: '#787878'}}><span style={{color: '#000000'}}>Finalizada em:</span> {vistoria?.finalVistoria ? moment(vistoria.finalVistoria).format('DD/MM/YYYY - HH:mm') : 'Inspeção não iniciada'}</div>
                    </div>
                :   <div style={{color: '#787878'}}><span style={{color: '#000000'}}>Finalizada em:</span> {vistoria?.finalVistoria ? moment(vistoria.finalVistoria).format('DD/MM/YYYY - HH:mm') : 'Inspeção em andamento'}</div> 
                }
            </div> 
        </div>

        <div style={{fontSize: 15, fontWeight: 'bold', color: '#000000', paddingLeft: 20, paddingRight: 20, marginBottom: 15}}>Informações gerais</div>

        
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start', paddingLeft: 20, paddingRight: 20}}>
            <div>
                <div style={{color: '#787878', fontSize: 13, marginBottom: 15, textAlign: 'left'}}>
                    {vistoria?.addressStreet}, {vistoria?.addressNum}<br />
                    {vistoria?.addressBairro} - {vistoria?.addressCidade} {vistoria?.addressUF}<br />
                    {vistoria?.addressCEP}
                </div>
            </div>
            <div style={{padding: 0, textAlign: 'right'}}>   
                <div style={{color: '#000000'}}>{vistoriaArray?.flatMap(v => v.equipe.filter(item => item.role === 'tecnico')).length === 1 ? 'Técnico responsável' : 'Técnicos responsáveis'}</div>
                {vistoriaArray?.flatMap(v => v.equipe.filter(item => item.role === 'tecnico' || item.role === 'admin').map(team => (
                        <div style={{color: '#787878'}}>{team.name} ({team.username})</div>
                        ))
                    )}
            </div>

        </div>
        <div style={{padding: 20}}>
                <div style={{padding: 0, textAlign: 'right'}}>   
                <div style={{color: '#000000'}}>Equipe</div>
                {vistoria?.equipe?.map(((team, index) => (
                        <div style={{color: '#787878'}}>
                            {index+1} - {team.name}
                            <button size="small" onClick={()=>{removeTeamMember(index)}} style={{width:20 ,marginLeft: 10, fontSize: 10, backgroundColor: '#f1f1f1', border: 'none', cursor: 'pointer'}}>X</button>

                        </div>
                        ))
                    )}
            </div>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'flex-end'}}>
                
                    <Button disableElevation size="small" variant="outlined" onClick={()=>{setOpenUsers(!openUsers)}} style={{marginTop: 10, textTransform: 'none'}}>
                        Adicionar membro à equipe
                    </Button>

                {openUsers ?
                    <div>
                        {team?.map((member, index) => (
                            <div key={index} style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', borderBottom: '1px solid #d9d9d9', paddingTop: 10, paddingBottom: 10}}>
                                <div style={{fontSize: 13}}>{member.name} ({member.username}) - {member.role === 'admin' ? 'EHS Admin' : member.role === 'tecnico' ? 'Técnico' : member.role === 'clienteAdm' ? 'Cliente Adm' : 'Cliente'}</div>
                                <Button disableElevation size="small" variant="contained" onClick={()=>{
                                    setVistoria(prev => ({
                                        ...prev,
                                        equipe: [...prev.equipe, {id: member.id, name: member.name, username: member.username, role: member.role}]
                                    }))
                                }} style={{marginTop: 10, marginLeft: 10,textTransform: 'none'}}>
                                    Adicionar
                                </Button>
                            </div>
                        ))}
                    </div>
                : null}


            </div>
        </div>
        <div style={{backgroundColor: '#f9f9f9', padding: 20, borderRadius: 12, marginBottom: 20}}>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', height: 50}}>
            <div style={{fontSize: 15, fontWeight: 'bold', color: '#000000', paddingLeft: 20, paddingRight: 20, marginBottom: 15}}>{titBoxPrincipal}</div> 
            {openNr > 0 ?
                <button onClick={()=>{ShowNr([], -1, 'Ocorrências')}} style={{backgroundColor: '#ff862b', border: 0, color: '#ffffff', fontSize: 14, padding: 8, paddingLeft: 20, paddingRight: 20,  borderRadius: 8, marginRight: '20%', marginBottom: 20}}>
                    ver ocorrências
                </button>
            : null}
        </div>


        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start'}}>
            <div style={{width: '80%', minHeight: 400, borderRadius: 18, padding: 20}} className='BoxNrs'>
                {openNr > 0 ?
                <>
                    <div style={{fontSize: 15, color: '#000000', marginBottom: 15}}>NR{nrContent.number} &nbsp; {nrContent.name}</div>
                    <div>
                        {nrContent?.items.map((item, index)=>(
                            <div style={{color: '#6b6b6b', fontSize: 12, marginBottom: 20}}>
                                    {index + 1}. {item.documento}<br />
                                    <div style={{marginBottom: 10, marginTop: 20}}>
                                        <strong>Status: {item.status === 'C' ? 'Em conformidade' : item.status === 'NA' ? 'Não se aplica' : item.status === 'N' ? 'Não conforme' : 'Não aferida'}</strong><br />
                                        {item.status === 'C' ? <strong>Justificativa: {item.conforme}</strong> : null}
                                        {item.status === 'NA' ? <strong>Justificativa: {item.na}</strong> : null}
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html:
                                                item.status === 'N'
                                                    ? `<strong>Ação:</strong> ${item.naoconforme.acao}<br />
                                                    <strong>Responsável:</strong> ${item.naoconforme.responsaveel}<br />
                                                    <strong>Conclusão:</strong> ${item.naoconforme.conclusao}`
                                                    : ''
                                            }}
                                        />
                                    </div>
                                    
                                    <hr />
                                    </div>
                            ))}
                        {/*8vistoriaArray.map((vistoria, vistoriaIndex) => (
                            vistoria.nrs.map((nr, nrIndex) => (
                                <div>
                                {nr.items.map((item, itemIndex) => (
                                    <div style={{color: '#6b6b6b', fontSize: 12, marginBottom: 20}}>
                                    {itemIndex + 1}. {item.documento}<br />
                                    <div style={{marginBottom: 10, marginTop: 20}}>
                                        <strong>Status: {item.status === 'C' ? 'Em conformidade' : item.status === 'NA' ? 'Não se aplica' : item.status === 'N' ? 'Não conforme' : 'Não aferida'}</strong><br />
                                        {item.status === 'C' ? <strong>Justificativa: {item.conforme}</strong> : null}
                                        {item.status === 'NA' ? <strong>Justificativa: {item.na}</strong> : null}
                                        {item.status === 'N' ? 
                                            `<strong>Ação:</strong> ${item.naoconforme.acao}<br />
                                            <strong>Responsável:</strong> ${item.naoconforme.responsaveel}<br />
                                            <strong>Conclusão:</strong> ${item.naoconforme.conclusao}`
                                            : null}
                                    </div>
                                    
                                    <hr />
                                    </div>
                                ))}
                                </div>
                            ))
                            ))*/}
                    </div>
                </>
                :
                <>
                    <div>
                        {vistoriaArray.map((vistoria, vistoriaIndex) => (
                            vistoria.ocorrencias.sort((a, b) => new Date(b.data) - new Date(a.data)).map((ocorrencia, ocorrenciaIndex) => (
                                <div key={`nr-${vistoriaIndex}-${ocorrenciaIndex}`}>
                                    <div style={{marginBottom: 15, borderRadius: 8, borderWidth: 1, borderColor: '#d9d9d9', borderStyle: 'solid'}}>    
                                        <button onClick={()=>{ShowOcorrencia(ocorrencia, openOcorrencia != 0 ? -1 : ocorrenciaIndex )}} style={{cursor: 'pointer', fontSize: 14, color: '#000000', width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', borderRadius: 8, border: 0, padding: 12, backgroundColor: '#ffffff'}}>
                                            {ocorrencia.nome}
                                            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end'}}>
                                                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', marginRight: 30}}>
                                                    {ocorrencia.status === 'pendente' ? 'Pendente' : ocorrencia.status === 'resolvido' ? 'Resolvida' : 'Atenção'}
                                                    <img src={ocorrencia.status === 'pendente' ? icoPendente : ocorrencia.status === 'resolvido' ? icoResolvido : icoAtencao} style={{width: 22, marginLeft: 20}} />
                                                </div>
                                                <img src={icoArrowRight} style={{width: 8, marginRight: 8}} />
                                            </div>
                                        </button>
                                        {openOcorrencia === ocorrenciaIndex + 1 ?
                                            <div style={{padding: 10, paddingBottom: 20}}>
                                                <div style={{marginBottom: 15}}>
                                                    <span style={{color: '#000000'}}>Descrição</span><br />
                                                    <span style={{color: '#787878'}}>{ocorrencia.descricao}</span>
                                                </div>
                                                <div style={{marginBottom: 15}}>
                                                    <span style={{color: '#000000'}}>Data de registro</span><br />
                                                    <span style={{color: '#787878'}}>{moment(ocorrencia.data).format('DD/MM/YYYY - HH:mm')}</span>
                                                </div>
                                                <div style={{marginBottom: 15}}>
                                                    <a href={`https://www.google.com/maps/@${ocorrencia?.localizacao?.latitude},${ocorrencia?.localizacao?.longitude}z`} target='_blank' style={{textDecoration: 'none'}}>
                                                        <span style={{color: '#000000'}}>Localização exata</span><br />
                                                        <span style={{color: '#787878'}}>Latitude: {ocorrencia?.localizacao?.latitude} / Longitude {ocorrencia?.localizacao?.longitude}</span>
                                                        <img src={icoNewWindow} style={{width: 15, marginLeft: 8}} />
                                                    </a>
                                                </div>
                                                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', flexWrap: 'wrap', marginTop: 20}}>
                                                    {ocorrencia.fotos.map((foto, index)=>(
                                                        <div key={index}>
                                                            <div style={{ textAlign: 'center',  width: 210, height: 118, borderWidth: 1, borderColor: '#d9d9d9', borderStyle: 'solid', backgroundColor: '#ebebeb', marginRight: 15}}>
                                                                <a href={foto.url} target='_blank' ><img src={foto.url} style={{maxWidth: 210, maxHeight: 118}} /></a>
                                                            </div>
                                                            <button style={{fontSize: 11, color: '#787878', textAlign: 'center', margin: 15, cursor: 'pointer'}}>
                                                                remover imagem
                                                            </button>
                                                        </div>
                                                    ))}
                                                </div>
                                                <div style={{marginBottom: 15, marginTop: 20}}>
                                                    <div style={{color: '#000000', fontSize: 15, marginBottom: 20}}>Histórico de interação</div>
                                                        {ocorrencia.interacao.map((inter, index)=>(
                                                            <div style={{ marginLeft: inter.role !== 'cliente' ? 25 : 0, marginRight: inter.role === 'cliente' ? 25 : 0, padding: 15, marginBottom: 15, borderStyle: 'solid', borderRadius: 12, borderWidth: 1, borderColor: inter.role != 'cliente' ? '#ff862b' : '#aaaaaa'}}>
                                                                <button onClick={()=>{setOpenReads(index)}} style={{backgroundColor: '#ffffff', cursor: 'pointer', border:0, textAlign: inter.role === 'cliente' ? 'left' : 'right', width: '100%'}}>
                                                                    <div style={{color: '#787878', fontWeight: 'bold'}}>{inter.remetente} - {inter.role}</div>
                                                                    <div style={{color: '#787878'}}>{moment(inter.data).format('DD/MM/YYYY - HH:mm')}</div>
                                                                    <div style={{color: '#787878', fontWeight: 'bold', marginTop: 15}}>Mensagem:</div>
                                                                    <div style={{color: '#787878'}}>{inter.mensagem}</div>
                                                                </button>
                                                                {openReads === index ? 
                                                                    <div style={{textAlign: inter.role === 'cliente' ? 'left' : 'right'}}>
                                                                        <button onClick={()=>{GetReads(inter.id)}} style={{cursor: 'pointer' ,fontSize: 12, padding: 10, marginTop: 15, marginBottom: 10, paddingLeft: 35, paddingRight: 35, borderRadius: 8, borderStyle: 'solid', borderWidth: 1, borderColor: '#ececec', backgroundColor: '#ffffff'                                                                    }}>
                                                                            Histórico de entrega das mensagens
                                                                        </button>
                                                                        
                                                                        {reads?.pushMessage !== undefined ?
                                                                        <div>
                                                                            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                                                                <div style={{width: 160, textAlign: 'left'}}>Data de envio</div>
                                                                                <div style={{display: 'flex', flex: 1, alignItems: 'flex-start'}}>Destinatário</div>
                                                                                <div style={{width: 70}}>Status</div>
                                                                            </div>
                                                                            {reads?.pushMessage?.destinatarios?.map((read)=>(
                                                                                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginBottom: 5}}>
                                                                                    <div style={{color: '#787878', width: 160, textAlign: 'left'}}>{moment(read.dataEnvio).format('DD/MM/YYYY - HH:mm')}</div>
                                                                                    <div style={{color: '#787878', display: 'flex', flex: 1, alignItems: 'flex-start'}}>{read.username}</div>
                                                                                    <div style={{color: '#787878', width: 70}}>{read.status}</div>
                                                                                </div>
                                                                            ))}
                                                                        </div>
                                                                        : null}
                                                                    </div>
                                                                : null}
                                                            </div>
                                                        ))}
                                                </div>
                                            </div>
                                        : null}
                                        
                                    </div>
                                </div>
                            ))
                        ))}
                    </div>
                </>
                }
            </div>

            <div style={{width: '20%', textAlign: 'right'}}>
                <div style={{marginBottom: 15, fontSize: 15}}>NRs aplicadas</div>
                {vistoriaArray?.flatMap(v => v.nrs.map((nr, index) => (
                    <div key={index} style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between'}}>
                        {openNr === index +1 ? <img src={orangeArrowRight} style={{width: 8}} /> : <div style={{width: 8}}></div>}
                        <button onClick={()=>{ShowNr(nr, index, 'Normas Regulamentadoras')}} style={{backgroundColor: openNr !== index +1 ? '#032461' : '#ff862b', border: 0, borderRadius: 8, paddingLeft: 40, paddingRight: 40, paddingBlock: 10, marginBottom: 7, color: '#ffffff', fontWeight: 'bold'}}>
                            NR {nr.number}
                        </button>
                    </div>
                    ))
                )}
            </div>
        </div>

        <div>            
            {vistoria.status === 'pendente' || vistoria.status === 'naoiniciada' || vistoria.status === 'atencao' ?
            
            null :  
                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', backgroundColor: '#ffffff', padding: 20, marginBlock: 20, borderRadius: 12}}>  
                    {vistoria.status === 'resolvido' || pdf ?
                        <>
                        <Button variant="contained" disableElevation size="large" style={{backgroundColor:"#ff862b"}} onClick={()=>{gerarPDF(vistoria)}}>Baixar PDF</Button>
                        &nbsp;&nbsp;<Button disabled variant="contained" disableElevation size="large">Finalizar Inspeção</Button>
                        </>
                    :
                        keepPriority && priority || userData.role === 'cliente' || userData.role === 'clienteAdm' ? null :
                        <>
                        <b>Atualizar Inspeção:</b> &nbsp;&nbsp;
                        <Button variant="outlined" disableElevation size="large" color='secondary' onClick={()=>{SaveServiceRevisar()}}>Enviar para revisão</Button>
                        &nbsp;&nbsp;<Button variant="contained" disableElevation size="large" style={{backgroundColor:"#00192d", color: '#ffffff'}} onClick={()=>{SaveServiceFinalizado()}}>Finalizar Inspeção</Button>
                        </>
                    }
                </div>
            }            
        </div>
</div>
</div>
        </Layout>
    </>
  );
};

const styles = {
    rowMain: {
        display: 'flex', 
        flexDirection: 'row', 
        alignItems: 'flex-start', 
        justifyContent: 'flex-start',
    },
    colEsq: {
        display: 'flex',
        width: 160,
        minWidth: 160,
        padding: 8,
        fontWeight: 600
    },
    colDir: {
        display: 'flex',
        padding: 8,
        flexDirection: 'column'
    },
    colMin: {
        display: 'flex',
        flexDirection: 'row'
    },
    nrItem: {
        marginTop: 5, 
        marginBottom: 5, 
        fontSize: 15, 
        fontWeight: 'bold',
        backgroundColor: '#ffffff',
        padding: 15,
        borderRadius: 8,
    },
    lidas : {

    }
}

export default VistoriaDetalhe
